
import { getComparePlansFetcher } from "@api/fetcher/ambassdor";
import { BatchPlan, BatchPlus } from "@components/Sales/batch.type";

import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

interface props {
    data: any;
    isLoading: boolean;
}

const useComparePlans = ({ batchId, enable }: { batchId: string, enable: boolean }): props => {
    const { data, isLoading } = useQuery({
        queryKey: ["get-compare-plans", { batchId }],
        queryFn: ({ queryKey }) => getComparePlansFetcher({ queryKey }),
        retry: false,
        enabled: !!enable,
        refetchOnWindowFocus: false,
    });

    const getPlansOffering = (
        planIndex: number,
        subHeadingIndex: number,
    ): boolean[] => {
        const offeringArray: boolean[] = [];
        data.plans?.forEach((planData: BatchPlan) => {
            const subOffering = planData?.offeringData[planIndex]?.subOffering;
            const subHeadingOffering = subOffering[subHeadingIndex];
            offeringArray.push(Boolean(subHeadingOffering));
        });
        return offeringArray;
    };

    const updateDescription = (data: BatchPlus) => {
        const updatedDescription: any[] = [];
        data.plans.forEach((_, planIndex: number) => {
            const planOffering = data.comparisonTable[planIndex];
            const offerings: any[] = [];

            planOffering?.offering?.forEach((offering, subHeadingIndex: number) => {
                offerings.push({
                    ...offering,
                    subOffering: getPlansOffering(planIndex, subHeadingIndex),
                });
            });

            updatedDescription.push({
                ...planOffering,
                offeringNew: offerings,
            });
        });
        return updatedDescription;
    };

    let updatedData = useMemo(() => {
        const d = new BatchPlus(data?.data?.data);

        if (d?.comparisonTable?.length > 0) {
            d["comparisonTable"] = updateDescription(new BatchPlus(d));
        }
        return d;
    }, [data]);

    return {
        data: updatedData,
        isLoading,
    };
};

export default useComparePlans;
